import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';


import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { MatCardModule } from '@angular/material/card';
import {
  MatChipsModule,
} from '@angular/material/chips';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { AsyncPipe } from '@angular/common';
import {
  MatAutocompleteModule,
} from '@angular/material/autocomplete';

import { RouterModule } from '@angular/router';
// @ts-ignore
import * as PlotlyJS from 'plotly.js-dist-min'
import { PlotlyModule } from 'angular-plotly.js';
PlotlyModule.plotlyjs = PlotlyJS;

import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AlertComponent } from './alert/alert.component';
import { FooterComponent } from './footer/footer.component'
import { FilterComponent } from './filter/filter.component';
import { ChartsCommonFunctions } from './charts/chartsCommonFunctions';
import { RetailerProfileComponent } from 'src/app/profiles/retailer-profile/retailer-profile.component';
import { ListProfileComponent } from 'src/app/profiles/list-profile/list-profile.component';

import { ShareButtonsModule} from 'ngx-sharebuttons/buttons';
import { ShareIconsModule} from 'ngx-sharebuttons/icons';
import { RxAuthService } from 'src/app/services/rx-auth/rx-auth.service';
import {MatListModule} from '@angular/material/list';
import {MatSidenavModule} from '@angular/material/sidenav';
import { PadlockComponent } from './padlock/padlock.component';
import { BackComponent } from './back/back.component';
import { OfflineModalComponent } from './offline-modal/offline-modal.component';
import { ContactPhoneDialogComponent } from './dialogs/contact-phone-dialog/contact-phone-dialog.component';




@NgModule({
  declarations: [
    AlertComponent,
    FooterComponent,
    FilterComponent,
    PadlockComponent,
    BackComponent,
  ],
  imports: [
    FontAwesomeModule,
    CommonModule,
    FormsModule,
    BrowserAnimationsModule,
    MatIconModule,
    MatButtonModule,
    MatMenuModule,
    MatSelectModule,
    MatFormFieldModule,
    MatChipsModule,
    MatCardModule,
    RouterModule,
    AsyncPipe,
    MatAutocompleteModule,
    ReactiveFormsModule,
    ShareIconsModule,
    ShareButtonsModule,
    MatListModule,
    MatSidenavModule,
    MatProgressSpinnerModule,
    OfflineModalComponent,
    MatTooltipModule
  ],
  exports: [
    FooterComponent,
    AlertComponent,
    FilterComponent,
    PadlockComponent,
  ],
  providers: [
    ChartsCommonFunctions,
    RetailerProfileComponent,
    ListProfileComponent,
    RxAuthService
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ToolboxModule {}
